// ─── BackToTop — floating "↑" button visible after the user scrolls down ───
// Sits just above the AI chat widget (same right anchor, +60px bottom).
// Smooth-scrolls the window back to the top on click. Auto-hides when the
// page is near the top.

import { useEffect, useState } from "react";
import { useTheme } from "../lib/ThemeContext.jsx";

const SHOW_AFTER_PX = 320;

export default function BackToTop() {
  const T = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      setVisible(y > SHOW_AFTER_PX);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      title="Back to top"
      aria-label="Back to top"
      style={{
        position: "fixed",
        right: 16,
        bottom: "max(92px, calc(env(safe-area-inset-bottom) + 84px))",
        zIndex: 9000,
        width: 44, height: 44, borderRadius: "50%",
        background: T.card,
        color: T.text,
        border: `1px solid ${T.border}`,
        boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
        cursor: "pointer",
        fontSize: 18, fontWeight: 700,
        display: "flex", alignItems: "center", justifyContent: "center",
        transition: "transform 0.15s, background 0.15s",
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.08)"; }}
      onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
    >
      ↑
    </button>
  );
}
